import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { CookieService } from 'services/cookie-service';

const SERVER_ADDRESS = `https://smartsar.kr/rescue/api/`;
const WEATHER_ADDRESS = `https://foxrainsea.koast.net:40082/voucher/api/`;
const SHIP_ADDRESS = `https://marinetraffic.kr/backend/api/`;
const FNOTE_ADDRESS = `https://fnote.kr/NavadaMap/api/`;
const RESTAPI_ADDRESS = `https://smartsar.kr/rest-api2/`;
const ONAVII_ADDRESS = `https://onavi.kr/user/api/`;
const LOOKNTELL_ADDRESS = `https://smartsar.kr/lookntellvms-bridge/api`;

export const axiosService: AxiosInstance = axios.create({
  baseURL: `${SERVER_ADDRESS}`,
});

export const weatherService: AxiosInstance = axios.create({
  baseURL: `${WEATHER_ADDRESS}`,
});

export const shipService: AxiosInstance = axios.create({
  baseURL: `${SHIP_ADDRESS}`,
});

export const fnoteService: AxiosInstance = axios.create({
  baseURL: `${FNOTE_ADDRESS}`,
});

export const onaviService: AxiosInstance = axios.create({
  baseURL: `${ONAVII_ADDRESS}`,
  headers: {
    'O-NAVI-DEFAULT': 'GOSTVN11',
  },
});

export const restApiService: AxiosInstance = axios.create({
  baseURL: `${RESTAPI_ADDRESS}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const lookntellApiService: AxiosInstance = axios.create({
  baseURL: `${LOOKNTELL_ADDRESS}`,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': 'nemo-web-dev-bb0be4ce',
  },
});

/**
 * @description API Common Header
 */
export function getHeaderToken() {
  const token = CookieService.getInstance().getToken();
  return {
    Authorization: token,
  };
}

/**
 * @param response
 * @description API 미들웨어 - 상태체크
 */
export function checkStatus(response: AxiosResponse) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  throw response;
}

export { axios };
